import { render } from "./MailboxRow.vue?vue&type=template&id=5d1fd278"
import script from "./MailboxRow.vue?vue&type=script&lang=js"
export * from "./MailboxRow.vue?vue&type=script&lang=js"
script.render = render

export default script